module.exports = __webpack_public_path__ + "static/media/Knob1.8d5b8079.png";